import script from "./SchoolStatusAI.vue?vue&type=script&setup=true&lang=js"
export * from "./SchoolStatusAI.vue?vue&type=script&setup=true&lang=js"

import "./SchoolStatusAI.vue?vue&type=style&index=0&id=80973ede&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80973ede"]])

export default __exports__